import React from 'react';

const StatusChip = ({ variant = 'neutral', children }) => (
  <span className={`cy-chip cy-chip--${variant}`}>{children}</span>
);

export default StatusChip;
